export default __webpack_public_path__ + "static/media/Karla-Regular.fc0a3514.ttf";